import styled, {css} from 'styled-components';

const Styled = styled.div`


    .upload-col {
        .ant-upload-wrapper {
            display: flex;
            flex-direction: column;
            
            .ant-upload {
                flex: 0 0 380px;
                background: #e6f7ff;
                border-radius: 6px;
        
                .ant-upload-hint {
                    padding: 0 20px;
                }
            }
        
            .ant-upload-list {
                .ant-upload-list-item-card-actions {
                    display: none;
                }
            }
        }
    }

    .whatsapp-content {
        display: flex;
        height: 181px;
        padding: 16px;
        text-align: center;
        background: #e6f7ff;

        .inner {
            margin: auto;
        }

        span {
            display: inline-block;
            padding-top: 6px;
            font-size: 13px;
            line-height: 1.3;
            color: #8c8c8c;
        }
    }

    .email-content {
        display: flex;
        height: 181px;
        padding: 16px;
        text-align: center;
        background: #e6f7ff;

        .inner {
            margin: auto;
        }

        span {
            display: inline-block;
            padding-top: 6px;
            font-size: 13px;
            line-height: 1.3;
            color: #8c8c8c;
        }
    }
`;

const ShoeboxUploadStyled = css`
    .shoebox-upload-modal {
        .ant-modal-header {
            /* background: #91d5ff; */
        }
    }
`;

export {Styled, ShoeboxUploadStyled};
